import { render, staticRenderFns } from "./scope116.vue?vue&type=template&id=2a3aefc6&scoped=true"
import script from "./scope116.vue?vue&type=script&lang=js"
export * from "./scope116.vue?vue&type=script&lang=js"
import style0 from "./scope116.vue?vue&type=style&index=0&id=2a3aefc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3aefc6",
  null
  
)

export default component.exports